import { Controller } from "@hotwired/stimulus";

// Thumbs on a Kit answer. Posts the rating and swaps itself for the server's
// rendered acknowledgement.
//
// Deliberately fire-and-forget from the customer's point of view: a failed
// rating must never interrupt the conversation, so a network error leaves the
// buttons in place to try again rather than surfacing an error state. The label
// stream is valuable, but not more valuable than the chat working.
export default class extends Controller {
  static values = { url: String };

  async rate(event) {
    const button = event.currentTarget;
    const rating = button.dataset.rating;
    if (!rating || this.submitting) return;

    this.submitting = true;
    this.element.querySelectorAll("button").forEach((b) => (b.disabled = true));

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
            ?.content,
          Accept: "text/html",
        },
        body: JSON.stringify({ rating }),
      });

      if (!response.ok) throw new Error(`rating failed: ${response.status}`);
      this.element.outerHTML = await response.text();
    } catch (error) {
      console.error("[message-feedback]", error);
      this.submitting = false;
      this.element
        .querySelectorAll("button")
        .forEach((b) => (b.disabled = false));
    }
  }
}
